import type { IFilterObject } from "@/lib/centra/useProductFilter/filterFormatter";

import UI from "./UI";

interface FilterGroupProps {
  filterGroup: {
    name: string;
    filters: IFilterObject[];
  };
  open: boolean;
}

const FilterGroup = ({ filterGroup, open }: FilterGroupProps) => {
  return <UI filterGroup={filterGroup} open={open} />;
};

export default FilterGroup;
